<main>
  <h1>Ato Koomson</h1>
</main>
<nav>
  <ul>
    <li><a routerLink="/home" routerLinkActive="active-link">Home</a></li>
    <li><a routerLink="/about" >About</a></li>
    <li>
      <a routerLink="/projects" >Projects</a>
    </li>
    <li><a routerLink="/about" >Contact</a></li>
  </ul>
</nav>
